export let APIStates = /*#__PURE__*/function (APIStates) {
  APIStates["Typing"] = "typing";
  APIStates["Loading"] = "loading";
  APIStates["Error"] = "error";
  APIStates["NoResult"] = "noresult";
  APIStates["Success"] = "success";
  return APIStates;
}({});
export let ProductStates = /*#__PURE__*/function (ProductStates) {
  ProductStates["PreQueryLoading"] = "PreQueryLoading";
  ProductStates["PostQueryLoading"] = "PostQueryLoading";
  ProductStates["PreQuerySuccess"] = "PreQuerySuccess";
  ProductStates["PostQuerySuccess"] = "PostQuerySuccess";
  ProductStates["PreQueryError"] = "PreQueryError";
  ProductStates["PostQueryError"] = "PostQueryError";
  ProductStates["PreQueryNoResult"] = "PreQueryNoResult";
  ProductStates["PostQueryNoResult"] = "PostQueryNoResult";
  ProductStates["PostQueryTyping"] = "PostQueryTyping";
  ProductStates["Invalid"] = "Invalid";
  return ProductStates;
}({});